import { message } from "antd";
import { useMutation } from "@tanstack/react-query";
import WarehouseService from "../../services/Warehouses/WarehouseService";
import { useNavigate } from "react-router-dom";
import ConfirmDeleteButton from "../../common/actions/ConfirmDeleteButton";
import { WAREHOUSE_SETTINGS_ROOT } from "../RouteConstants";

const WarehouseDelete = ({ warehouseId, queryClient }) => {
  const navigate = useNavigate();
  const { mutate } = useMutation({
    mutationFn: async () => await WarehouseService.deleteWarehouse(warehouseId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["warehouses"] });
      navigate(WAREHOUSE_SETTINGS_ROOT, { replace: true });
      message.success("Warehouse deleted successfully!");
    },
    onError: async (error) => {
      message.error(`Failed to delete warehouse. ${error.response?.data?.message}, Please try again.`);
    },
  });

  return (
    <>
      <ConfirmDeleteButton title={`Are you sure you want to delete this warehouse?`} onConfirm={mutate} />
    </>
  );
};

export default WarehouseDelete;